module.exports = __webpack_public_path__ + "static/media/menu.0b489da7.svg";